import "./App.css";
import "./responsive/breakpoint-1160px.css";
import "./responsive/breakpoint-992px.css";
import "./responsive/breakpoint-768px.css";
import "./responsive/breakpoint-576px.css";
import "./responsive/breakpoint-480px.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";
import React, { useLayoutEffect, lazy, Suspense, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// Redux
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/auth";
import setAuthToken from "./utils/setAuthToken";
import { LOGOUT } from "./actions/types";

library.add(fas);

const LoadingPage = lazy(() => import("./components/LoadingPage"));
const Sidebar = lazy(() => import("./components/layout/Sidebar/Sidebar"));
const Home = lazy(() => import("./pages/Home"));
const Packages = lazy(() => import("./components/Packages"));
const Subscriptions = lazy(() => import("./components/Subscriptions"));
const Class = lazy(() => import("./components/Class"));
const Note = lazy(() => import("./components/Note"));
const AddSubscription = lazy(() => import("./components/AddSubscription"));
const ClassList = lazy(() => import("./components/ClassList"));
const GroupList = lazy(() => import("./components/GroupList"));
const Notifications = lazy(() => import("./components/Notifications"));
const ChangePassword = lazy(() => import("./pages/ChangePassword"));
const Login = lazy(() => import("./components/Login"));
const Alert = lazy(() => import("./components/Alert"));
const Marketing = lazy(() => import("./pages/Marketing/Marketing"));
const Crm = lazy(() => import("./pages/CRM/Crm"));
const StartPointPayment = lazy(() => import("./pages/StartPointPayment"));
const Settings = lazy(() => import("./pages/Settings/Settings"));
const Expenses = lazy(() => import("./pages/Expenses/Expenses"));
const Incomes = lazy(() => import("./pages/Incomes/Incomes"));
const TrainerPayment = lazy(() =>
  import("./pages/TrainerPayment/TrainerPayment")
);
const PricePackages = lazy(() => import("./pages/PricePackages/PricePackages"));

const PrivateRoute = lazy(() => import("./components/routing/PrivateRoute"));

// cookies
const addCookie = () => {
  const cookieName = "plesk_technical_domain";
  const cookieValue = "1";

  if (!document.cookie.includes(`${cookieName}=${cookieValue}`)) {
    document.cookie = `${cookieName}=${cookieValue}`;
  }
};

function App() {
  const token = localStorage.token;
  if (token) {
    setAuthToken(token);

    if (!store.getState().auth.isAuthenticated) {
      store.dispatch(loadUser());
    }
  }
  window.addEventListener("storage", () => {
    // if (!localStorage.token) store.dispatch({ type: LOGOUT });
  });

  // (2 saat)
  const inactivityTimeout = 2 * 60 * 60 * 1000;

  // hereketsiz olduqda bagla
  function checkInactivity() {
    const lastInteraction = parseInt(localStorage.getItem("lastInteraction"));
    if (Date.now() - lastInteraction > inactivityTimeout) {
      store.dispatch({ type: LOGOUT });
    }
  }

  // Her saniyye hereketsizliyi yoxlamaq uchun
  setInterval(checkInactivity, 1000);

  //
  function resetInactivityTimer() {
    localStorage.setItem("lastInteraction", Date.now().toString());
  }

  //
  document.addEventListener("mousemove", resetInactivityTimer);
  document.addEventListener("keydown", resetInactivityTimer);

  // Sehife yuklenende sifirla
  resetInactivityTimer();

  useEffect(() => {
    addCookie();
  }, []);

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Suspense fallback={<LoadingPage />}>
            <Routes>
              <Route
                path="/"
                element={
                  <Wrapper>
                    <Sidebar />
                    <Alert />
                    <Outlet />
                  </Wrapper>
                }
              >
                <Route index element={<Home />} />
                <Route
                  path="packages"
                  element={<PrivateRoute component={Packages} />}
                />
                <Route
                  path="subscriptions"
                  element={<PrivateRoute component={Subscriptions} />}
                />
                <Route
                  path="class"
                  element={<PrivateRoute component={Class} />}
                />
                <Route
                  path="marketing"
                  element={<PrivateRoute component={Marketing} />}
                />
                <Route path="crm" element={<PrivateRoute component={Crm} />} />
                <Route
                  path="startpointpayment"
                  element={<PrivateRoute component={StartPointPayment} />}
                />
                <Route
                  path="expenses"
                  element={<PrivateRoute component={Expenses} />}
                />
                <Route
                  path="incomes"
                  element={<PrivateRoute component={Incomes} />}
                />
                <Route
                  path="pricepackages"
                  element={<PrivateRoute component={PricePackages} />}
                />
                <Route
                  path="trainerpayment"
                  element={<PrivateRoute component={TrainerPayment} />}
                />

                <Route
                  path="note"
                  element={<PrivateRoute component={Note} />}
                />
                <Route
                  path="addsubscription"
                  element={<PrivateRoute component={AddSubscription} />}
                />
                <Route
                  path="classlist"
                  element={<PrivateRoute component={ClassList} />}
                />
                <Route
                  path="grouplist"
                  element={<PrivateRoute component={GroupList} />}
                />
                <Route
                  path="notifications"
                  element={<PrivateRoute component={Notifications} />}
                />
                <Route
                  path="changepassword"
                  element={<PrivateRoute component={ChangePassword} />}
                />
                <Route
                  path="settings"
                  element={<PrivateRoute component={Settings} />}
                />
              </Route>
              <Route path="/login" element={<Login />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
